var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('Faq',{attrs:{"custom-faq":_vm.customFaq,"title":_vm.title,"prismic-props":_vm.prismicProps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }